import React from "react";
export default function Footer(){
    return <div className={'text-center input-box bg-secondary text-white mt-5 p-2'}>
        <p className={'m-0'}>تمامی حقوق نرم‌افزار انتخاب رشته ارشد ۱۴۰۳ متعلق به وب سایت مشاوران تحصیلی است</p>
    </div>
}
